import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

function Navigation() {
  const [isCollapsed, setIsCollapsed] = useState(true); 
  const location = useLocation(); 


  useEffect(() => {
    setIsCollapsed(true); 
  }, [location]); 

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed); 
  };

  return (
    <div className="navigation">
      <nav className="navbar sticky navbar-expand-sm navbar-dark bg-dark">
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar} 
          aria-controls="x"
          aria-expanded={!isCollapsed} 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isCollapsed ? '' : 'show'}`} id="x">
          <NavLink className="nav-link navbar-brand" to="/">
            DIY-Heritage
          </NavLink>
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/archive">
                  Archive
                </NavLink>
              </li>    
              <li className="nav-item">
                <NavLink className="nav-link" to="/map">
                  Map
                </NavLink>
              </li>     
              <li className="nav-item">
                <NavLink className="nav-link" to="/projects">
                  Projects
                </NavLink>
              </li>                                                   
             <li className="nav-item">
                <NavLink className="nav-link" to="/about">
                  About
                </NavLink>
              </li>                                                          

              
       {/*                                    
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Manage
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item dropdown" href="/add">Edit</a></li>
            <li><a class="dropdown-item" href="/list">List</a></li>
            <li>
                <a class="dropdown-item" >Manage &raquo; </a>
                <ul class="dropdown-menu dropdown-submenu">
                  <li>
                    <a class="dropdown-item" href="/add">Resource</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="/manage/project">Project</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="/manage/person">Person</a>
                  </li>
                </ul>
              </li>
          </ul>
        </li>
        */}

        <li className="nav-item-end">
            <NavLink className="nav-link" 
                    to="mailto:contact.diyheritage@gmail.com"
                    target="_blank" 
                    rel="noopener noreferrer">
                  Contact
            </NavLink>
        </li>     
 
 {/*    


       <li className="nav-item">
                <NavLink className="nav-link" to="/signup">
                  Signup
                </NavLink>
              </li>                                               */}
            </ul>

          </div>
    {/*      <div className="ml-auto">
          <form class="form-inline my-2 my-bg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Arama yap" aria-label="Search" />
      <button className="btn btn-success" type="submit">Ara</button>
    </form>
     </div>  */}
      </nav>
      
    </div>
  );
}

export default Navigation;
